// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
var isProduction = process.env.NODE_ENV === 'production';
let base = 'http://localhost:8009';

if (isProduction) {
    base = ""
}
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);
// require("swiper/dist/css/swiper.css");
// // require styles
// import 'swiper/dist/css/swiper.css'


// Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.prototype.base = base;
Vue.config.productionTip = false
window.Vue = Vue;
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
// new Vue({
//   el: '#app',
//   router,
//   template: '<App/>',
//   components: { App }
// })



// WEBPACK FOOTER //
// ./src/main.js